import CrossIcon from 'components/icons/CrossIcon';
import React, { PureComponent } from 'react';

const CSS = require('./Tag.module.scss');

interface TagProps {
  onRemove: (keyword: string) => void;
  name: string;
}

class Tag extends PureComponent<TagProps> {
  onRemove = () => {
    this.props.onRemove(this.props.name);
  };

  render() {
    const { name } = this.props;
    if (!name) {
      return null;
    }
    return (
      <button key={name} className={CSS.Tag} onClick={this.onRemove}>
        {name}
        <span className={CSS.CrossIconContainer}>
          <CrossIcon className={CSS.CrossIcon} width={8} height={8} />
        </span>
      </button>
    );
  }
}

export default Tag;
